import { ref } from 'vue'
import PageModal from '@/components/PageModal.vue'

type modalCallbackFn = (item?: any) => void

export function usePageModal(
  newCb?: modalCallbackFn,
  editCb?: modalCallbackFn
) {
  const pageModalRef = ref<InstanceType<typeof PageModal>>()
  const defaultInfo = ref<any>({})
  const handleNewData = () => {
    defaultInfo.value = {}

    if (pageModalRef.value) {
      pageModalRef.value.dialogVisible = true
      pageModalRef.value.isBatch = false
      pageModalRef.value.isAdd = true
    }
    newCb && newCb()
  }

  const handleEditData = (item: any) => {
    defaultInfo.value = { ...item }
    if (pageModalRef.value) {
      pageModalRef.value.dialogVisible = true
      pageModalRef.value.isBatch = false
      pageModalRef.value.isAdd = false
    }
    editCb && editCb(item)
  }
  return [pageModalRef, defaultInfo, handleNewData, handleEditData]
}

export interface PointReasonItem {
  value: string
  title: string
  point: number
}

export const createFilter = (queryString: string) => {
  return (restaurant: PointReasonItem) => {
    return (
      restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
    )
  }
}

const decultPointRestaurants = [
  { title: '代金券100元', value: '代金券100元', point: 2000 },
  { title: '代金券200元', value: '代金券200元', point: 3999 },
  { title: 'PC端软件1个月使用权', value: 'PC端软件1个月使用权', point: 10000 },
  { title: '程老师独家战法一套', value: '程老师独家战法一套', point: 4000 },
  { title: '精选研报1份', value: '精选研报1份', point: 2000 },
  { title: '票池服务期7天', value: '票池服务期7天', point: 1000 },
  { title: '票池服务期15天', value: '票池服务期15天', point: 2000 },
  { title: '名师诊股报告', value: '名师诊股报告', point: 4000 },
  { title: '精选付费课程', value: '精选付费课程', point: 1000 },
  { title: '精选票池', value: '精选票池', point: 6600 },
  {
    title: '《与牛共舞实战操盘宝典》',
    value: '《与牛共舞实战操盘宝典》',
    point: 8800
  }
]

export function useModalDecultPointReason(
  restaurant: PointReasonItem[] = decultPointRestaurants
) {
  const fetchSuggestions = (queryString: string, cb: any) => {
    const results = queryString
      ? restaurant.filter(createFilter(queryString))
      : restaurant
    // call callback function to return suggestions
    cb(results)
  }
  return [fetchSuggestions]
}
